<template>
    <div id="aprication">
        <div class="headerp-div">
            <div class="header-div">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :key="crumbs" v-for="crumbs in $crumbsList()">{{crumbs}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="header-div" style="text-align: right">
                <div style="float: right">
                    <el-button size="mini" v-if="$hasPerm('business:initialFinancialBalance:add')" @click="handleAdd()"
                               style=";background-color:#16E3A1;color: white">初始化余额<i class="el-icon-plus"></i>
                    </el-button>
                </div>
            </div>
        </div>

        <div style="width: 100%;height: 100%;display:flex;flex-direction:column;">
            <el-tabs v-model="activeName" type="card" @tab-click="handleCurrentChange">
                <el-tab-pane label="资产" name="ZC"></el-tab-pane>
                <el-tab-pane label="负债" name="FZ"></el-tab-pane>
                <el-tab-pane label="权益" name="QY"></el-tab-pane>
                <el-tab-pane label="成本" name="CB"></el-tab-pane>
                <el-tab-pane label="损益" name="SY"></el-tab-pane>
            </el-tabs>
        </div>

        <div class="ch_panel" id="queryDiv2" style="height: 460px; overflow: auto;">
            <el-table :data="tableData" border size="mini" height="460" style="width: 100%" id="elTableIdWWQQQ">
                <el-table-column label="序号" type="index" width="77"></el-table-column>
                <el-table-column prop="dicCode" label="科目类别编码" width="136"></el-table-column>
                <el-table-column label="科目类别名称" width="360">
                    <template slot-scope="scope">
                        <span v-if="scope.row.levelNum=='2'" style="padding-left: 20px;">{{scope.row.dicName}}</span>
                        <span v-else-if="scope.row.levelNum=='3'" style="padding-left: 40px;">{{scope.row.dicName}}</span>
                        <span v-else-if="scope.row.levelNum=='4'" style="padding-left: 60px;">{{scope.row.dicName}}</span>
                        <span v-else-if="scope.row.levelNum=='5'" style="padding-left: 80px;">{{scope.row.dicName}}</span>
                        <span v-else-if="scope.row.levelNum=='6'" style="padding-left: 100px;">{{scope.row.dicName}}</span>
                        <span v-else>{{scope.row.dicName}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="余额方向" width="99">
                    <template slot-scope="scope">
                        <span v-if="scope.row.yueFx=='1'">借</span>
                        <span v-if="scope.row.yueFx=='-1'">贷</span>
                    </template>
                </el-table-column>
                <el-table-column label="期初余额(元)">
                    <template slot-scope="scope">
                        <input v-if="isCanEdit && scope.row.chileCount==0" :value="scope.row.qiChuValue"
                               @change="inputChange(scope.row,'qiChuValue')" onkeyup="value=value.replace(/[^\d.]/g,'')"
                               placeholder="0.00"
                               :rowId="scope.row.id" tp="qiChuValue"/>
                        <span v-if="!isCanEdit || scope.row.chileCount > 0">{{scope.row.qiChuValue}}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="(isView!=1)?'本年累计借方(元)':''">
                    <template slot-scope="scope" v-if="isView!=1">
                        <input v-if="isCanEdit && scope.row.chileCount==0" :value="scope.row.bnljJfValue"
                               @change="inputChange(scope.row,'bnljJfValue')" placeholder="0.00"
                               onkeyup="value=value.replace(/[^\d.]/g,'')" :rowId="scope.row.id" tp="bnljJfValue"/>
                        <span v-if="!isCanEdit || scope.row.chileCount > 0">{{scope.row.bnljJfValue}}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="(isView!=1)?'本年累计贷方(元)':''">
                    <template slot-scope="scope" v-if="isView!=1">
                        <input v-if="isCanEdit && scope.row.chileCount==0" :value="scope.row.bnljDfValue"
                               @change="inputChange(scope.row,'bnljDfValue')" placeholder="0.00"
                               onkeyup="value=value.replace(/[^\d.]/g,'')" :rowId="scope.row.id" tp="bnljDfValue"/>
                        <span v-if="!isCanEdit || scope.row.chileCount > 0">{{scope.row.bnljDfValue}}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="(isView!=1)?'年初余额(元)':''">
                    <template slot-scope="scope" v-if="isView!=1">
                        <span>{{scope.row.nianChuValue}}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="(isView!=1)?'实际损益发生额(元)':''">
                    <template slot-scope="scope" v-if="activeName=='SY' && isView!=1">
                        <input v-if="isCanEdit && scope.row.chileCount==0" :value="scope.row.shiJiSunYiValue"
                               @change="inputChange(scope.row,'shiJiSunYiValue')" placeholder="0.00"
                               onkeyup="value=value.replace(/[^\d.]/g,'')" :rowId="scope.row.id" tp="shiJiSunYiValue"/>
                        <span v-if="!isCanEdit || scope.row.chileCount > 0">{{scope.row.shiJiSunYiValue}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'initialFinancialBalanceList',
        data() {
            return {
                tableData: [],
                activeName: 'ZC',
                isCanEdit: false,
                isView: 0,
                lastLieBie: 'ZC',
            }
        },
        methods: {
            handleCurrentChange() {
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/initialFinancialBalance/searchList'),
                    method: 'post',
                    data: this.$httpTAG.adornData({
                        'leiBie': this.activeName
                    })
                }).then(res => {
                    if (res.data.code == 0) {

                        if (this.activeName == 'SY' && res.data.data.isView == 1) {
                            this.$message({
                                type: 'warning',
                                message: "年初启用的账套，不需要录入损益初始余额哦！"
                            })
                            this.activeName = this.lastLieBie;
                            return false;
                        }

                        this.tableData = res.data.data.list;
                        this.isCanEdit = res.data.data.isCanEdit;
                        this.isView = res.data.data.isView;

                        this.lastLieBie = this.activeName;
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                }).finally(r => {
                })
            },
            inputChange(row, key) {

                let input = $("#elTableIdWWQQQ .el-table__body-wrapper tbody").find("input[rowId='" + row.id + "'][tp='" + key + "']");
                input.val($.trim(input.val()))

                let val = 0 ;
                if (input.val() != '') {
                    val = Number(input.val());
                }

                this.$httpTAG({
                    url: this.$httpTAG.adornUrl("/business/initialFinancialBalance/save"),
                    method: 'post',
                    data: this.$httpTAG.adornData({
                        "key" : key,
                        "val" : val,
                        "keMuId" : row.id
                    })
                }).then(res => {
                    if (res.data.code == 0) {
                        this.$notify({
                            title: '操作成功！',
                            type: 'success',
                            offset: 600
                        });
                        this.handleCurrentChange();
                    } else {
                        this.$message({ // 失败
                            type: 'fail',
                            message: res.data.msg
                        })
                    }
                })


            }
        },
        created: function () {
            this.handleCurrentChange();
        }
    }
</script>
<style scoped>
    .header-div {
        margin-bottom: 5px;
        float: left;
        width: 50%;
    }

    input {
        width: 96%;
        height: 32px;
        font-size: 14px;
        color: #686868;
        border: 1px solid #d3d6dd;
        padding-left: 5px;
    }

    .queryInput >>> .el-input__inner {
        border-radius: 0px;
        width: 200px;
    }
</style>